export default __webpack_public_path__ + "static/media/img1.e82fc2d8.png";